import { useEffect } from "react";

const ChatbotLoader = () => {
  useEffect(() => {
    if (document.getElementById("zsiqscript")) return;

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      ready: function () {},
    };

    const script = document.createElement("script");
    script.id = "zsiqscript";
    script.src =
      "https://salesiq.zohopublic.com/widget?wc=siq0e849344bed5e0154251c82d975fdf363cbc69b2b68881d0eec35a1681f15f21";
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
};

export default ChatbotLoader;

//   <script>window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}</script><script id="zsiqscript" src="https://salesiq.zohopublic.com/widget?wc=siq0e849344bed5e0154251c82d975fdf363cbc69b2b68881d0eec35a1681f15f21" defer></script>
